const DOCUMENT_VIEWER_MODEL_PATTERN =
    /\/redirections\/[^/]+\/document-viewer\/model(?:\?|$)/;

class DocumentViewerService {
    constructor() {
        this.viewerData = null;
        this.listeners = [];
    }

    isViewerModelUrl = (url) => Boolean(
        url && DOCUMENT_VIEWER_MODEL_PATTERN.test(url)
    );

    resolveDialogueUrl = (url) => {
        if (!url) return url;

        const configuredServer = process.env.REACT_APP_DIALOG_SERVER_URL;
        const server = configuredServer && configuredServer !== ''
            ? configuredServer
            : window.location.origin;
        const path = this.extractPath(url);
        return new URL(path, `${server.replace(/\/$/, '')}/`).toString();
    };

    extractPath = (url) => {
        if (/^https?:\/\//i.test(url)) {
            try {
                const parsed = new URL(url);
                return parsed.pathname + parsed.search;
            }
            catch (e) {
                /* fall through */
            }
        }
        return url;
    };

    open = (modelUrl, redirection) => {
        const basePath = this.extractPath(modelUrl).replace(/\/model(?:\?.*)?$/, '');
        const fileName = (redirection && redirection.fileName) || 'document';
        const contentType = (redirection && redirection.contentType) || 'application/octet-stream';
        const extension = this.extensionFrom(fileName, contentType);
        const editable = extension === 'pdf';

        this.viewerData = {
            fileName,
            contentType,
            extension,
            editable,
            contentUrl: this.resolveDialogueUrl(`${basePath}/content`),
            downloadUrl: this.resolveDialogueUrl(`${basePath}/content?download=true`),
            replaceUrl: editable ? this.resolveDialogueUrl(`${basePath}/replace`) : undefined,
        };
        this.notify();
    };

    close = () => {
        this.viewerData = null;
        this.notify();
    };

    subscribe = (listener) => {
        this.listeners.push(listener);
        listener(this.viewerData);
        return () => {
            this.listeners = this.listeners.filter((item) => item !== listener);
        };
    };

    notify = () => {
        this.listeners.forEach((listener) => listener(this.viewerData));
    };

    extensionFrom = (fileName, contentType) => {
        if (fileName) {
            const dot = fileName.lastIndexOf('.');
            if (dot >= 0) {
                return fileName.substring(dot + 1).toLowerCase();
            }
        }
        const ct = (contentType || '').toLowerCase();
        if (ct === 'application/pdf') return 'pdf';
        if (ct === 'model/gltf-binary') return 'glb';
        if (ct === 'model/gltf+json') return 'gltf';
        if (ct === 'model/stl') return 'stl';
        if (ct === 'video/mp4') return 'mp4';
        if (ct === 'video/webm') return 'webm';
        if (ct === 'video/ogg') return 'ogg';
        if (ct === 'audio/mpeg') return 'mp3';
        if (ct === 'audio/wav') return 'wav';
        if (ct === 'audio/ogg') return 'oga';
        const imageMatch = ct.match(/^image\/(\w+)/);
        if (imageMatch) return imageMatch[1];
        return 'bin';
    };
}

const documentViewer = new DocumentViewerService();
export default documentViewer;
